import { FuelTypography } from '@frete.com/fuel-react';
import React from 'react';
import * as Styled from './EmptyStateStyles';

function EmptyState() {
  return (
    <Styled.Content>
      <Styled.Wrapper>
        <Styled.DistanceWhiteIcon />
        <FuelTypography size="body-sm" color="neutral-strong" weight="medium">
          Esta viagem não possui origem e destino e estamos sem localização do
          motorista.
        </FuelTypography>
      </Styled.Wrapper>
    </Styled.Content>
  );
}

export default EmptyState;
